import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { Toaster } from 'sonner';
import { QueryClientProvider } from '@tanstack/react-query';

import { AppProvider } from '@/contexts/AppContext';
import { AuthProvider } from '@/contexts/AuthContext';
import { VerificationProvider } from '@/contexts/VerificationContext';
import { ConfirmProvider } from '@/shared/components/ui/ConfirmProvider';
import { router } from '@/lib/router';
import { createQueryClient } from '@/lib/query-client';
import { useRegisterPWA } from '@/pwa/useRegisterPWA';
import { PWAInstallBanner } from '@/pwa/PWAInstallBanner';
import { EnablePushBanner } from '@/pwa/EnablePushBanner';
import './index.css';

// Configuração do React Query (retries, aviso de erro de rede) em lib/query-client.ts
const queryClient = createQueryClient();

function PWAProvider({ children }: { children: React.ReactNode }) {
  useRegisterPWA();
  return <>{children}</>;
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <AppProvider>
        <PWAProvider>
          <AuthProvider>
            <VerificationProvider>
              <ConfirmProvider>
                <RouterProvider router={router} />
              </ConfirmProvider>
              <Toaster
                position="top-center"
                richColors
                duration={4000}
                toastOptions={{
                  style: {
                    borderRadius: '10px',
                    fontSize: '13px',
                  },
                }}
              />
              {/* iOS não tem beforeinstallprompt — o banner é o único caminho de instalação guiada */}
              <PWAInstallBanner />
              {/* Push no iOS/PWA exige gesto do usuário — o prompt nasce do toque neste banner */}
              <EnablePushBanner />
            </VerificationProvider>
          </AuthProvider>
        </PWAProvider>
      </AppProvider>
    </QueryClientProvider>
  </React.StrictMode>
);